import React from 'react';

export const CloneIcon = (props) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M12.2308 15.9375H3.92308C3.67826 15.9375 3.44347 15.84 3.27036 15.6666C3.09725 15.4931 3 15.2578 3 15.0125V4.8375M5.46154 2.0625H14.3846C14.3846 2.0625 15 2.0625 15 2.67917V13.4708C15 13.4708 15 14.0875 14.3846 14.0875H5.46154C5.46154 14.0875 4.84615 14.0875 4.84615 13.4708V2.67917C4.84615 2.67917 4.84615 2.0625 5.46154 2.0625Z"
      stroke="#8D90A5"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
